export enum RccapPhase {    
    Unknown = 0,
    MatchOffer = 1,
    XmDonorReview = 2,
    PostXmPreKickoff = 3,
    PostKo = 4
}